import { CSSProperties, createContext } from "react";

export const AlertContext = createContext<{
  setAlert: (messageToSet: string, styleProperty?: CSSProperties) => any;
}>({ 
    setAlert: () => {} 
});
